import styled from 'styled-components';

const StyledHeadline = styled.h1.withConfig({
    displayName: "styles__StyledHeadline",
    componentId: "sc-b988b8f5-0"
})`
    color: ${(props)=>props.titleColor ?? props.theme.colors.Foreground};
    padding-bottom: ${({ theme  })=>theme.spacers.XXL};
    ${({ theme  })=>theme.typography.Headline};
`;
const StyledSubHeadline = styled.h2.withConfig({
    displayName: "styles__StyledSubHeadline",
    componentId: "sc-b988b8f5-1"
})`
    color: ${(props)=>props.titleColor ?? props.theme.colors.Foreground};
    padding-bottom: ${({ theme  })=>theme.spacers.L};
    ${({ theme  })=>theme.typography.Subheadline}
`;
const StyledSuperTinyHeadline = styled.h3.withConfig({
    displayName: "styles__StyledSuperTinyHeadline",
    componentId: "sc-b988b8f5-2"
})`
    color: ${(props)=>props.titleColor ?? props.theme.colors.Foreground};
    padding-bottom: ${({ theme  })=>theme.spacers.M};
    ${({ theme  })=>theme.typography.SuperTinyHeadline}
`;
const StyledSmallCapsHeadline = styled.h4.withConfig({
    displayName: "styles__StyledSmallCapsHeadline",
    componentId: "sc-b988b8f5-3"
})`
    color: ${(props)=>props.titleColor ?? props.theme.colors.Foreground};
    padding-bottom: 12px;
    ${({ theme  })=>theme.typography.SmallCapsHeadline}
`;
const StyledParagraph = styled.p.withConfig({
    displayName: "styles__StyledParagraph",
    componentId: "sc-b988b8f5-4"
})`
    color: ${(props)=>props.paragraphColor ?? props.theme.colors["Level 5"]};

    ${({ theme  })=>theme.typography.Paragraph}

    > a {
        color: ${(props)=>props.paragraphColor ?? props.theme.colors["Level 5"]};
        text-decoration: underline;
    }
`;

export { StyledHeadline, StyledParagraph, StyledSmallCapsHeadline, StyledSubHeadline, StyledSuperTinyHeadline };
